module.exports = __webpack_public_path__ + "88a8ad5c76c691ad52282cc8effb12db.svg";